<template>
  <div>
    {{order}}
  </div>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementScalePropTableColumn} from "@/mixins/elementScalePropTableColumn";
import {mapGetters} from "vuex";

export default {
  name: 'element-order-kpi-table-column',
  components: {ClickToEdit},
  mixins: [ElementScalePropTableColumn],

  props: {},

  computed: {

    ...mapGetters('card/sections', {
      sections: 'sections',
      sectionsElements: 'sectionsElements'
    }),
    order() {
      const thisSectionType = this.scope._self.section.type;
      if( thisSectionType === 'kpi_required' ){
        return this.scope.$index+1;
      }

      const requiredSection = this.sections.find(s => s.type === 'kpi_required');
      const requiredSectionCount = requiredSection ? this.sectionsElements[requiredSection.id]?.length : 0;

      if( thisSectionType === 'kpi_functional' ){
        return requiredSectionCount + (+this.scope.$index+1);
      }

      const functionalSection = this.sections.find(s => s.type === 'kpi_functional');
      const functionalSectionCount = functionalSection ? this.sectionsElements[functionalSection.id]?.length : 0;

      if( thisSectionType === 'kpi_direct_chief' ){
        return requiredSectionCount + functionalSectionCount + (+this.scope.$index+1);
      }

      const careerSection = this.sections.find(s => s.type === 'kpi_direct_chief');
      const careerSectionCount = careerSection ? this.sectionsElements[careerSection.id]?.length : 0;

      if( thisSectionType === 'kpi_dart_trr' ){
        return requiredSectionCount + functionalSectionCount + careerSectionCount + (+this.scope.$index+1);
      }

      return 999;
    },
  },
  data() {
    return {

    }
  },

  methods: {

  }
}

</script>

<style>

</style>
